import React, { useEffect, useState } from 'react';
import view from '../assets/View.svg';
import SearchBar from '../Components/SearchBar';
import Pagination from '../Components/Pagination';
import './css/Bookings.css';
import TopBar from '../Components/TopBar';
import instance from '../utils/api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from '../assets/Loading.svg';
import { Button } from '@mui/material';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';



// const data = [
//     { User_name: "Satya", Booking_date: "2024-07-31", Service: "plumbing", Booking_status: "Accept", Service_Prov_name: "Carpenter", Location: "KBHP,Hyderabad", MobileNo: "7468592567" },
//     { User_name: "Anjani", Booking_date: "2024-07-28", Service: "plumbing", Booking_status: "Accept", Service_Prov_name: "Plumber", Location: "KBHP,Hyderabad", MobileNo: "7468592567" },
//     { User_name: "Shiva", Booking_date: "2024-07-22", Service: "plumbing", Booking_status: "Cancel", Service_Prov_name: "Carpenter", Location: "KBHP,Hyderabad", MobileNo: "7468592567" },
//     { User_name: "Akhil", Booking_date: "2024-07-30", Service: "plumbing", Booking_status: "Accept", Service_Prov_name: "Plumber", Location: "KBHP,Hyderabad", MobileNo: "7468592567" }
// ]
const list = [
    { id: "1", name: "All Categories" },
    { id: "2", name: "Recently added" },
    { id: "3", name: "Deleted" }
]

const Bookings = () => {
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const rowsPerPage = 10;
    const startindex = (page - 1) * rowsPerPage;
    const [loading, setLoading] = useState(true);




    const handleBooking = async () => {
        try {
            const response = await instance.get('api/Admin/getBookingList');
            console.log(response.data);
            setData(response.data.orders);
            setFilteredData(response.data.orders);
        } catch (error) {
            console.log(error);
            toast.error(error.data.message);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        handleBooking();
    }, []);

    const handleExport = async () => {
        try {
            // Make an API request to download the file
            const response = await instance.get('/api/Admin/exportBookingData')

            // Create a URL for the downloaded file
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'bookingData.csv'); // Set the file name
            document.body.appendChild(link);
            link.click(); // Programmatically click the link to trigger download
        } catch (error) {
            console.error('Error exporting data:', error);
        }
    };

    const dataToShow = filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage);
    return (
        <div>
            <TopBar title={"Bookings"} />
            {loading ?
                (
                    <div className="loading-spinner">
                        <img src={Loading} alt="loading" height={80} width={80} />
                    </div>
                ) :
                (<div className='_2wae'>
                    <div className="forget-hark">
                        <SearchBar data={data} setFilteredData={setFilteredData} filterKey={'userId.name'} />

                        <div className="filters">
                            <Pagination page={page} setPage={setPage} count={data.length} rowsPerPage={rowsPerPage} />
                            <Button onClick={handleExport}>Export Data</Button>
                            {/* <TableFilter data={data} setFilteredData={setFilteredData} filterKey={'student_id.first_name'} /> */}
                        </div>
                    </div>
                    <div className='studentportal'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th id='ms-1'>S.No</th>
                                    <th id='as-1'>Order ID</th>
                                    <th id='as-1'>User Name</th>
                                    <th id='ms-1'>Mobile Number</th>
                                    <th id='ms-1'>Booking Date</th>
                                    <th id='ms-1'>Service</th>
                                    <th id='ps'>Booking Status</th>
                                    <th id='ps'>Service Provider Name</th>
                                    <th id='ps'>Location</th>
                                    {/* <th id='hs-1'>Mobile Number</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {dataToShow.map((data, item) => (
                                    <tr key={item} >
                                        <td className='cuatros-pegs'>{startindex + item + 1}</td>
                                        <td className='cuatros-pegs'>{data?.order_id}</td>
                                        <td className='cuatros-pegs'>{data?.userId?.name}</td>
                                        <td className='cuatros-pegs'>{data?.userId?.mobile_no}</td>
                                        <td className='cuatros-pegs'>{data?.order_date}</td>
                                        <td className='cuatros-pegs'>{data?.service?.name}</td>
                                        <td className='prawners-bind-1'>{data?.order_Status}</td>
                                        <td className='prawners-bind-1'>{data?.service_provider_id?.name}</td>
                                        <td className='prawners-bind-1'>{data?.userId?.location}</td>
                                        {/* <td className='prawners-bind-1'>{data.MobileNo}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>)}
        </div>
    )
}

export default Bookings
